import type { FunctionComponent } from "react"

import { Heading } from "@jobteaser/spark/components/Heading"
import { Layout, LAYOUT_COLOR_BLOCK } from "@jobteaser/ui-kit/components/Layout/Layout"

import { DeepDiveKeyInformation } from "@/features/companyDetail/components/Index/DeepDiveKeyInformation/DeepDiveKeyInformation"
import { VideosGallery } from "@/features/companyDetail/components/Index/MediaGallery/VideosGallery"
import { useCompanyFetch } from "@/modules/companies/hooks/useCompanyFetch"
import { useTranslation } from "@/modules/i18n/components/useTranslation"

import styles from "./DeepDive.module.css"

export const DeepDive: FunctionComponent = () => {
  const { t } = useTranslation(["companies_client"])
  const { dataCompany, isSuccessCompany } = useCompanyFetch()

  if (!dataCompany || !isSuccessCompany) return null

  return (
    <Layout colorBlock={LAYOUT_COLOR_BLOCK.WHITE} data-testid="company_information_deep_dive">
      <Layout.Column>
        <Heading
          className={styles.deepDive__title}
          data-testid="company_information_deepDive_title"
          as="h2"
          variant="title2"
          weight="bold"
        >
          {t("companies_client.information.deepDive.title", { name: dataCompany.page.name })}
        </Heading>
        <VideosGallery />
        <DeepDiveKeyInformation />
      </Layout.Column>
    </Layout>
  )
}
